export class MessagingHelper {

    success = false;
    message = "";
    obj: any = null;

    constructor() {
    }
}